import { Dialog, DialogContent } from "@mui/material"


export const ImageViewer = ({ open, handleClose, selectedImage }) => {

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xl"
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
    >
      <DialogContent
        style={{
          padding: 0,
          maxWidth: '90vw',
          maxHeight: '90vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img
          src={selectedImage}
          alt="Vista ampliada"
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
          }}
        />
      </DialogContent>
    </Dialog>
  )
}